import { render, staticRenderFns } from "./BProcesso.vue?vue&type=template&id=090f9aed"
import script from "./BProcesso.vue?vue&type=script&lang=js"
export * from "./BProcesso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports